<template>
  <section class="share-price-bar">
    <BaseContainer>
      <div class="share-price-bar__wrapper">
        <div class="share-price-bar__price">
          <TextLine class="share-price-bar__text" color="white">Share price</TextLine>
          <TextLine class="share-price-bar__amount" color="white" size="xl">
            255.00
            <TextLine class="share-price-bar__currency" color="white">GBp</TextLine>
          </TextLine>
        </div>
        <div class="share-price-bar__changes">
          <div>
            High
            <TextLine color="white" semi>256.35</TextLine>
          </div>
          <div>
            Low
            <TextLine color="white" semi>253.86</TextLine>
          </div>
          <div>
            Change
            <TextLine color="white" semi>-0.05</TextLine>
          </div>
        </div>
        <div class="share-price-bar__timestamp">
          <span class>Last update: 20 Feb 2019 - 9.43 am (LSE)</span>
        </div>
      </div>
      <BaseButton class="share-price-bar__button" variant="opaque" width="small">
        <span>Financial Reports</span>
      </BaseButton>
    </BaseContainer>
  </section>
</template>

<script>
import BaseButton from '../elements/BaseButton.vue'
import TextLine from '../elements/TextLine.vue'
import BaseContainer from '../elements/BaseContainer.vue'
export default {
  name: 'SharePricerBar',
  components: { BaseContainer, TextLine, BaseButton }
}
</script>


<style lang="postcss">
.share-price-bar {
  @apply bg-primary py-2;
}
.share-price-bar .container {
  @apply flex;
}
.share-price-bar__wrapper {
  @apply flex flex-wrap content-center;
}
.share-price-bar__price {
  @apply flex items-center mr-4;
}
.share-price-bar__text {
  @apply pr-2 text-sm whitespace-no-wrap tracking-wide;
}
.share-price-bar__amount {
  @apply whitespace-no-wrap;
}
.share-price-bar__currency {
  @apply text-sm font-normal tracking-wide;
}
.share-price-bar__changes {
  @apply items-center text-white bg-primary-dark px-4 mx-4 hidden;
}
.share-price-bar__changes div {
  @apply px-4;
}
.share-price-bar__button {
  @apply ml-auto my-2 text-sm;
}
.share-price-bar__timestamp {
  @apply mr-2 self-center text-base;
}
.share-price-bar__timestamp span {
  @apply text-white-50 text-sm tracking-wide;
}
@screen md {
  .share-price-bar {
    @apply py-0;
  }
  .share-price-bar__price {
    @apply mr-0;
  }
  .share-price-bar__currency,
  .share-price-bar__text {
    @apply text-base;
  }
  .share-price-bar__timestamp {
    @apply mx-6;
  }
  .share-price-bar__timestamp span {
    @apply whitespace-no-wrap;
  }
}
@screen lg {
  .share-price-bar__changes {
    @apply flex;
  }
  .share-price-bar__wrapper {
    align-content: stretch;
  }
  .share-price-bar__timestamp {
    @apply mx-0;
  }
}
</style>

